import {Component, Input, OnInit} from '@angular/core';
import {IModel} from '../../shared/view-model/imodel.interface';
import {Barcode} from '../model/barcode.interface';
import {DepotService} from '../../store-management/services/depot-service/depot.service';

@Component({
  selector: 'vb-identities',
  templateUrl: './identities.component.html',
  styleUrls: ['./identities.component.css']
})
export class IdentitiesComponent implements OnInit {

  @Input()
  model: IModel;

  @Input()
  identities: Barcode[];

  constructor(private depotService: DepotService) {

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/identity/identities/identities.component.ts